import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { Provider } from "react-redux";
import { store } from "./store";
import { useAppSelector } from "@/store/hooks.ts";
import AuthContext from "@/hoc/AuthContext";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import { I18nSync } from "@i18n/I18nSync.tsx";

// Create a new router instance
export const router = createRouter({
  routeTree,
  context: {
    session: store.getState().auth,
  },
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  // eslint-disable-next-line
  interface Register {
    router: typeof router;
  }
}

// eslint-disable-next-line react-refresh/only-export-components
function App() {
  const session = useAppSelector((state) => state.auth);

  return (
    <AuthContext>
      <RouterProvider router={router} context={{ session }} />
    </AuthContext>
  );
}

// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <Provider store={store}>
        <I18nSync>
          <App />
        </I18nSync>
      </Provider>
    </StrictMode>
  );
}
